import { servicesApi } from '@/services/api';
import type { ServicesApiDomain } from '@/services/api/services-api';
import { createOnDemandCollection } from './create-collection';

/**
 * Domain collections for the current workspace.
 *
 * **`domains.list`** — sending domains (on-demand)
 * ```ts
 * const { data } = useLiveQuery((q) =>
 *   q.from({ d: domains.list })
 *     .where(({ d }) => eq(d.verified, true))
 * );
 * ```
 */
export const domains = {
  list: createOnDemandCollection<ServicesApiDomain>({
    id: 'domains',
    getKey: (item) => item.id,
    queryFn: async (workspaceId) => {
      const data = await servicesApi.getDomains({
        params: { workspaceId },
      });
      return data.domains ?? [];
    },
  }),
};
